import classNames from "classnames";
import { GlideFC } from "lib/glide-fc";

import { AppIconImpl } from "common/named-icons";
import { ButtonStyleProps, getIconSize } from "./button-vnext-lib";

import { Button } from "./button-vnext-style";
import { GlideIcon, isMonotoneIcon, isStrokeIcon, isTwotoneIcon } from "sharedUI/ui/views/glide-icon/glide-icon";

type Props = ButtonStyleProps;
export const ButtonVNext: GlideFC<Props> = p => {
    const { href, icon, label, onClick, className } = p;
    const buttonContents = (
        <div className={"button-container"}>
            {isStrokeIcon(icon) && (
                <GlideIcon
                    className={classNames("named-icon", p.isProcessing && "hide")}
                    kind="stroke"
                    icon={icon}
                    iconSize={getIconSize(p.size, p.iconType, p.split)}
                />
            )}
            {isMonotoneIcon(icon) && (
                <GlideIcon
                    className={classNames("named-icon", p.isProcessing && "hide")}
                    kind="monotone"
                    icon={icon}
                    iconSize={getIconSize(p.size, p.iconType, p.split)}
                />
            )}
            {isTwotoneIcon(icon) && (
                <GlideIcon
                    className={classNames("named-icon", p.isProcessing && "hide")}
                    kind="twotone"
                    icon={icon}
                    iconSize={getIconSize(p.size, p.iconType, p.split)}
                />
            )}
            <span className={classNames("label", p.isProcessing && "hide")}>{label}</span>
            {p.isProcessing && (
                // this must not be left in the DOM as it will chew up CPU time
                <AppIconImpl
                    className={classNames("process-icon")}
                    icon={"halfSpinner"}
                    size={getIconSize(p.size, p.iconType, p.split)}
                />
            )}
        </div>
    );

    if (href !== undefined) {
        return (
            <Button
                className={classNames(className, p.split)}
                {...p}
                as={"a"}
                href={href}
                target="_blank"
                rel="noopener noreferrer">
                {buttonContents}
            </Button>
        );
    }

    return (
        <Button className={classNames(className, p.split)} {...p} onClick={onClick}>
            {buttonContents}
        </Button>
    );
};
